import { createBrowserRouter } from "react-router-dom";
import Home from "../pages/main/home";
import Login from "../pages/auth/login";
import GlobalLayout from "../components/layouts/global-layout";
import MainLayout from "@/pages/main/components/layout";
import ForgotPassword from "@/pages/auth/forgot-password";
import ResetPassword from "@/pages/auth/reset-password";
import TransactionDetail from "@/pages/main/transaction-detail";
import Monthly from "@/pages/main/monthly";
import Budgets from "@/pages/main/budgets";
import Balance from "@/pages/main/balance";
import Reports from "@/pages/main/reports";
import More from "@/pages/main/more";
import AuthLayout from "@/pages/auth/components/auth-layout";
import BudgetDetails from "@/pages/main/budget-details.tsx";
import BalanceDetail from "@/pages/main/balance-detail";
import Invoices from "@/pages/main/invoices";
import InvoicesMonthly from "@/pages/main/invoices-monthly";
import InvoiceDetail from "@/pages/main/invoice-detail";
import TaskDetail from "@/pages/main/task-detail";
import OnboardingRequired from "@/pages/main/onboarding-required";

export const router = createBrowserRouter([
  {
    element: <GlobalLayout />,
    children: [
      {
        path: "/",
        element: <MainLayout />,
        children: [
          {
            path: "/",
            element: <Home />,
          },
          {
            path: "/transaction/:id",
            element: <TransactionDetail />,
          },
          {
            path: "/task/:id",
            element: <TaskDetail />,
          },
          {
            path: "/budgets",
            element: <Budgets />,
          },
          {
            path: "/budgets/:id",
            element: <BudgetDetails />,
          },
          {
            path: "/invoices",
            element: <Invoices />,
          },
          {
            path: "/invoices/:id",
            element: <InvoiceDetail />,
          },
          {
            path: "/invoices/monthly",
            element: <InvoicesMonthly />,
          },
          {
            path: "/balance",
            element: <Balance />,
          },
          {
            path: "/balance/:id",
            element: <BalanceDetail />,
          },
          {
            path: "/monthly",
            element: <Monthly />,
          },
          {
            path: "/reports",
            element: <Reports />,
          },
          {
            path: "/more",
            element: <More />,
          },
          {
            path: "/onboarding-required",
            element: <OnboardingRequired />,
          },
        ],
      },
      {
        element: <AuthLayout />,
        children: [
          {
            path: "/login",
            element: <Login />,
          },
          {
            path: "/forgot-password",
            element: <ForgotPassword />,
          },
          {
            path: "/reset-password",
            element: <ResetPassword />,
          },
        ],
      },
    ],
  },
]);
